import { loadTealium, trackEvent as tealiumTrackEvent, trackPage as tealiumTrackPage } from './Tealium';
import {
  identify as segmentIdentify,
  initPageCall as segmentInitPageCall,
  trackEvent as segmentTrackEvent,
  trackForm as segmentTrackForm,
  trackFormError as segmentTrackFormError,
  trackPage as segmentTrackPage,
} from './Segment';
import config from 'Config/analytics.json';

const TRACKING_ENUMS = (config && config.enums) || {};

const trackPage = (name, pathName, eventName) => {
  // for tealium
  tealiumTrackPage(name, pathName, eventName);
  // for segment
  segmentTrackPage(name, pathName, eventName);
};

const initPageCall = (name, pathName, eventName) => {
  // for tealium
  tealiumTrackPage(name, pathName, eventName);
  // for segment
  segmentInitPageCall(name, pathName, eventName);
};

const trackFormStarted = (name, segmentProperties = null) => {
  segmentTrackForm(TRACKING_ENUMS.EVENT_STARTED, name, segmentProperties);
};

const trackFormCompleted = (name, segmentProperties = null) => {
  segmentTrackForm(TRACKING_ENUMS.EVENT_COMPLETED, name, segmentProperties);
};

const trackFormError = (name, error, segmentProperties = null) => {
  segmentTrackFormError(name, error, segmentProperties);
};

const trackEvent = (event, segmentProperties = null, tealiumProperties = null) => {
  segmentTrackEvent(event, segmentProperties);
  tealiumTrackEvent(event, tealiumProperties);
};

const identify = (userId, anonymousId) => {
  segmentIdentify(userId, anonymousId);
};

export {
  TRACKING_ENUMS,
  trackPage,
  initPageCall,
  trackFormStarted,
  trackFormCompleted,
  trackFormError,
  trackEvent,
  identify,
  segmentTrackEvent,
  tealiumTrackEvent,
  loadTealium,
};
